var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(" ECL "+_vm._s(_vm.ecl)+"  "),(_vm.icon)?_c('span',{staticClass:"icon"},[_c('i',{class:['mdi', _vm.icon, 'mdi-24px']})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }